import { render, staticRenderFns } from "./AvaliacaoEditar.vue?vue&type=template&id=f6acfc38&"
import script from "./AvaliacaoEditar.vue?vue&type=script&lang=js&"
export * from "./AvaliacaoEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports